export default __webpack_public_path__ + "static/media/male_face.8970ee58.png";